import { GroupNodeTag } from "../../canvas/model/graph-model"
import { LinqsetNode, NODE_SUPERTYPE, NODE_TYPE } from "../../common/linqset-model"
import { ModelDetails } from "../../common/organisation"

export enum NODE_TYPE_DATA_TYPE {
    STANDARD,
    INPUT,
    OUTPUT,
    GROUP,
    MODELS
}

export const dataTypeUsesTotals = (dataType:NODE_TYPE_DATA_TYPE, superType:NODE_SUPERTYPE) => {
    return dataType === NODE_TYPE_DATA_TYPE.INPUT || dataType === NODE_TYPE_DATA_TYPE.OUTPUT || superType === NODE_SUPERTYPE.OUTCOMES
}

export class NodeTypeData {
    lazy:boolean=false              // whether data is lazy loaded or not (loaded on demand)
    list: LinqsetNode[]
    groups: GroupNodeTag[]
    models: ModelDetails[]
    subTypes: NodeTypeData[]
    count:number=0              // used when lazy loaded, gives number of items that will load
    comparisonCount:number=0    // used when lazy loaded, gives number of items that will load in comparison
    
    comparisonList:LinqsetNode[]
    comparisonModels:ModelDetails[]

    constructor(public name:string, public dataType: NODE_TYPE_DATA_TYPE, public colour:string, public hoverColour:string, public superType?:NODE_SUPERTYPE, public type?:NODE_TYPE) {}
    
    get usesTotals():boolean {
        return dataTypeUsesTotals(this.dataType, this.superType)
    }

    get length() {
        if (this.lazy) {
            return this.count
        }
        switch (this.dataType) {
            case NODE_TYPE_DATA_TYPE.GROUP:
                return this.groups?.length||0
            case NODE_TYPE_DATA_TYPE.MODELS:
                return this.models?.length||0
            default:
                return this.list?.length||0
        
        }
    }

    get comparisonLength() {
        if (this.lazy) {
            return this.comparisonCount
        }

        switch (this.dataType) {
            case NODE_TYPE_DATA_TYPE.GROUP:
                return 0
            case NODE_TYPE_DATA_TYPE.MODELS:
                return this.comparisonModels?.length||0
            default:
                return this.comparisonList?.length||0
        
        }
    }

    get helpMessage() {
        if (this.dataType === NODE_TYPE_DATA_TYPE.GROUP) {
            return "The model has been organised into groups. This shows the totals for the nodes within each group. Is only available model is grouped."
        }
        if (this.dataType === NODE_TYPE_DATA_TYPE.MODELS) {
            return "Shows the totals for each model in the organisation (and selected workspace). Is only available in organisation model."
        }
        if (this.dataType === NODE_TYPE_DATA_TYPE.INPUT) {
            return "Shows capture/input nodes that set the frequency (load) of items/data entering the model."
        }
        if (this.dataType === NODE_TYPE_DATA_TYPE.OUTPUT) {
            return "Shows the outputs produced by models. The values shown are the totals (of all actions) to produce the output."
        }
        switch (this.superType) {
            case NODE_SUPERTYPE.ACTION:
                return "Shows all action nodes in this model. This includes outcomes and capture (input) nodes. Action nodes describes work performed and have a duration (time taken to perform action on a single piece of information)"
            case NODE_SUPERTYPE.INFORMATION:
                if (this.name === "Output") 
                    return "Shows all the output (last) information nodes in this model. These are the information nodes that are the result of this process."
                else return "Shows all information nodes in this model. Information represents data, artefacts or items that are produced or changed by actions."
            case NODE_SUPERTYPE.INFRASTRUCTURE:
                return "Shows all infrastructure nodes in the organisation. Systems use infrastructure to run. These nodes are used to describe carbon emissions and costs of running systems."
            case NODE_SUPERTYPE.NOTES:
                return "Shows all notes, comments to things todo."
            case NODE_SUPERTYPE.PEOPLE:
                return "Shows all people within the organsation. People define capacity and costs. They are associated with roles (skils) that perform work."
            case NODE_SUPERTYPE.ROLE:
                return "Shows all roles within the model. Roles define skillsets capable of doing work (performing actions). They may define capacity and costs within the organisation."
            case NODE_SUPERTYPE.SYSTEM:
                return "Shows all systems within the model. Systems are used to perform actions or supply information. They may define costs of running the system."
            case NODE_SUPERTYPE.OUTCOMES:
                return "Shows all outcomes. Outcomes define the results of a business function and should define the value that they provide to the organisation. The values shown are the totals (of all actions) to produce the outcome."                
        }
    }

}
